import {array, boolean, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {stringOptionalNullable} from '@shared/utils';

export const userReportV8nSchema = object().shape({
  id: string().required(),
  reporter_id: string().required(),
  reporter_username: string().required(),
  reported_user_id: string().required(),
  reported_username: string().required(),
  cause: stringOptionalNullable,
  processed: boolean().required(),
  created_at: string().required(),
});

export const v8nSchemaOfGetReportsResponse = paginationV8nSchema.shape({
  array: array().of(userReportV8nSchema).required(),
});
